module.exports = __webpack_public_path__ + "img/企业信用等级证书.bd761d7f.png";